import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";
import type { Emoji } from "./emoji";

export class EmojiTypeaheadOption extends MenuOption {
  emoji: Emoji;
  display: React.JSX.Element;

  constructor(emoji: Emoji, display: React.JSX.Element) {
    super(emoji.id);
    this.emoji = emoji;
    this.display = display;
  }
}
